import styled from 'styled-components';
import Close from '@carvana/icons/Close';

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(24, 53, 88, 0.3);
  z-index: 1050;
`;

const ModalContent = styled.div<{
  whiteBg: boolean;
  fullscreenOnMobile: boolean;
}>`
  position: fixed;
  right: 0;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  border-radius: 3px;
  max-width: ${props => (props.fullscreenOnMobile ? '100%' : '320px')};
  margin: 0 auto;
  background: ${props => (props.whiteBg
      ? props.theme.carvana.white.primary
      : props.theme.carvana.gray.background)};
  height: ${props => (props.fullscreenOnMobile ? '100%' : 'auto')};
  z-index: 1051;
  overflow-y: auto;

  @media (min-width: 768px) {
    max-height: 95vh;
    max-width: 704px;
    height: auto;
  }
`;

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  color: ${props => props.theme.carvana.blue.dark};
  background: ${props => props.theme.carvana.white.primary};
  padding: 15px 0;
  box-shadow: 0px 2px 4px -1px rgba(25, 41, 61, 0.18);
  z-index: 300;
  @media (min-width: 768px) {
    position: relative;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
  }
`;

const ModalHeader = styled.h5`
  font-size: 14px;
  line-height: 1;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  margin: 0 auto;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const ModalCloseButton = styled.div`
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 15px;
  cursor: pointer;
  line-height: 1;
`;

const CloseIcon = styled(Close)`
  > svg {
    width: 13px;
    height: 13px;
  }
`;

export { ModalBackdrop, ModalContent, HeaderContainer, ModalHeader, ModalCloseButton, CloseIcon };
